import axios from "axios";
import Grid from "@material-ui/core/Grid";
import Slider from "@material-ui/core/Slider";
import Config from "../common/Config";
import FieldState from "../common/FieldState";
import OrderFormStep from "../common/OrderFormStep";
import "./forms.scss";
import FormTitle from "../components/formTitle/FormTitle";
import InputTextField from "../components/textField/InputTextField";
import MuiRadio from "../components/radio/MuiRadio";
import RangeSlider from "../components/range/RangeSlider";
import "react-toastify/dist/ReactToastify.css";
import Button from "../components/button/Button";
import SecondaryButton from "../components/button/SecondaryButton";
import { CreateNotification } from "../components/notification/Notification";
import SaveAsDraft from "../components/modal/SaveAsDraft";

export default class PatientInfo1 extends OrderFormStep {
  constructor(props) {
    super(props);

    this.uomMetric = 1;
    this.uomImperial = 2;
    this.heightConversionFactor = 2.54;

    this.weightConversionFactor = 2.205;

    this.state = {
      // validationResult: new ValidationResult(),
      // pageLoading: false,
      // formSubmitted: false,
      accountNumber: localStorage.getItem("accountNumber"),
      patientInfo1UOMs: [],
      kLevels: [],
      isSubmit: false,
      footDirections: [],
      personalData: {},
      formState: {
        // patientName: new FieldState(false),
        patientId: new FieldState(true),
        patientInfo1UOM: new FieldState(false),
        heightFt: new FieldState(false, 1),
        heightIn: new FieldState(false, 0),
        heightCm: new FieldState(false, 30),
        weightKg: new FieldState(false, 1),
        weightLbs: new FieldState(false, 2),
        isBilateral: new FieldState(false, false),
        kLevel: new FieldState(true),
        footDirection: new FieldState(true),
        footSize: new FieldState(false, 22),
      },

      selectedValue: "",
    };

    this.handleHeightFtChange = this.handleHeightFtChange.bind(this);
    this.handleHeightInChange = this.handleHeightInChange.bind(this);
    this.handleHeightCmChange = this.handleHeightCmChange.bind(this);
    this.handleWeightKgChange = this.handleWeightKgChange.bind(this);
    this.handleWeightLbsChange = this.handleWeightLbsChange.bind(this);
    this.onCheckChange = this.onCheckChange.bind(this);
    this.handleFootSizeChange = this.handleFootSizeChange.bind(this);
  }

  componentDidMount() {
    this.loadData();
    this.loadPoNumber();
  }

  async loadData() {
    try {
      this.setState({
        kLevels: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "kLevel" },
            }
          )
        ).data,
        patientInfo1UOMs: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "patientInfo1UOM" },
            }
          )
        ).data,

        footDirections: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "footDirection" },
            }
          )
        ).data,
      });

      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
        },
        params: {
          fieldNames: [
            "patientInfo1UOM",
            "height",
            "weight",
            "kLevel",
            "footDirection",
            "footSize",
          ],
        },
      };

      const { data } = await axios.get(
        Config.baseApiUrl + "patientInfo1s/" + this.props.formTypeId,
        config
      );

      let formState = this.state.formState;
      // formState.patientName.value = data.patientName;
      formState.patientId.value = data.patientId;
      formState.isBilateral.value = data.isBilateral;
      formState.footDirection.value = data.fieldInputs.find(
        (fi) => fi.fieldName === "footDirection"
      ).fieldOptionId;
      formState.patientInfo1UOM.value =
        data.fieldInputs.find((fi) => fi.fieldName === "patientInfo1UOM")
          .fieldOptionId ?? this.uomMetric;

      formState.kLevel.value = data.fieldInputs.find(
        (fi) => fi.fieldName === "kLevel"
      ).fieldOptionId;

      let height = data.fieldInputs.find(
        (fi) => fi.fieldName === "height"
      ).numericData;
      let weight = data.fieldInputs.find(
        (fi) => fi.fieldName === "weight"
      ).numericData;

      let isMetric = formState.patientInfo1UOM.value === this.uomMetric;
      if (isMetric) {
        this.setCmState(height);
        this.setKgState(weight);
      } else {
        this.setInchesState(height);
        this.setLbsState(weight);
      }

      let footSize = data.fieldInputs.find(
        (fi) => fi.fieldName === "footSize"
      ).numericData;
      
      if (footSize !== null) {
        formState.footSize.value = footSize;
      }

      this.setState({ formState: formState });
    } catch (error) {
      // this.props.handleError(new LoadFailureResult());
    }

    this.setState({ isLoaded: true });
  }

  async loadPoNumber() {
    try {
      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
        },
      };

      const { data } = await axios.get(
        Config.baseApiUrl + "clinicinfos/" + this.props.formTypeId,
        config
      );
      let personalData = this.state.personalData;
      personalData = data;
      this.setState({ personalData: personalData });
    } catch (e) {
      console.log(e);
    }
  }

  saveData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };
    const form = this.state.formState;
    const mappedArray = [];
    for (const value of Object.values(form)) {
      mappedArray.push(value);
    }
    let data = {
      patientId: this.state.formState.patientId.value,
      isBilateral: this.state.formState.isBilateral.value,
      accountNumber: this.state.accountNumber,
      fieldInputs: [],
    };


    data.fieldInputs.push({
      fieldName: "kLevel",
      fieldOptionId: this.state.formState.kLevel.value,
    });

    data.fieldInputs.push({
      fieldName: "patientInfo1UOM",
      fieldOptionId: this.state.formState.patientInfo1UOM.value,
    });

    data.fieldInputs.push({
      fieldName: "footDirection",
      fieldOptionId: this.state.formState.footDirection.value,
    });

    let isMetric = this.state.formState.patientInfo1UOM.value === 1;
    data.fieldInputs.push({
      fieldName: "height",
      numericData: isMetric
        ? this.state.formState.heightCm.value
        : this.state.formState.heightFt.value * 12 +
          this.state.formState.heightIn.value,
    });
    data.fieldInputs.push({
      fieldName: "weight",
      numericData: isMetric
        ? this.state.formState.weightKg.value
        : this.state.formState.weightLbs.value,
    });

    data.fieldInputs.push({
      fieldName: "footSize",
      numericData: this.state.formState.footSize.value,
    });

    if (
      this.validateData().isValid &&
      this.state.personalData.poNumber !== "" &&
      this.state.personalData.poNumber !== 0 &&
      this.state.personalData.poNumber !== null
    ) {
      axios.post(
        Config.baseApiUrl + "clinicinfos/" + this.props.formTypeId,
        this.state.personalData,
        config
      );

      return axios.post(
        Config.baseApiUrl + "patientInfo1s/" + this.props.formTypeId,
        data,
        config
      );
    } else {
      this.setState({
        isSubmit: true,
      });
      CreateNotification("Missing data in required fields", "error");

      return null;
    }
  }

  onCheckChange(e) {
    let formState = this.state.formState;
    formState.isBilateral.value = e.target.checked;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  handleFootSizeChange(e, value) {
    let formState = this.state.formState;
    formState.footSize.value = e;
    this.setState({ formState: formState, hasDataChanged: true });
  }


  handleHeightFtChange(e, value) {
    let formState = this.state.formState;
    formState.heightFt.value = e;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  handleHeightInChange(e, value) {
    let formState = this.state.formState;
    formState.heightIn.value = e;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  handleHeightCmChange(e, value) {
    let formState = this.state.formState;
    formState.heightCm.value = e;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  handleWeightKgChange(e, value) {
    let formState = this.state.formState;
    formState.weightKg.value = e;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  handleWeightLbsChange(e, value) {
    let formState = this.state.formState;
    formState.weightLbs.value = e;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  setInchesState(inches) {
    if (inches === null) return;
    let formState = this.state.formState;
    formState.heightFt.value = Math.floor(inches / 12);
    formState.heightIn.value = inches % 12;
    this.setState({ formState: formState });
  }

  setCmState(cm) {
    if (cm === null) return;
    let formState = this.state.formState;
    formState.heightCm.value = cm;
    this.setState({ formState: formState });
  }

  calculateInches() {
    let heightCm = this.state.formState.heightCm.value;
    return Math.round(heightCm / this.heightConversionFactor);
  }

  calculateCm() {
    let heightFt = this.state.formState.heightFt.value;
    let heightIn = this.state.formState.heightIn.value;

    heightIn += heightFt * 12;
    return Math.round(heightIn * this.heightConversionFactor);
  }

  setKgState(kg) {
    if (kg === null) return;
    let formState = this.state.formState;
    formState.weightKg.value = kg;
    this.setState({ formState: formState });
  }

  setLbsState(lbs) {
    if (lbs === null) return;
    let formState = this.state.formState;
    formState.weightLbs.value = lbs;
    this.setState({ formState: formState });
  }

  calculateKg() {
    let weightLbs = this.state.formState.weightLbs.value;
    return Math.round(weightLbs / this.weightConversionFactor);
  }

  calculateLbs() {
    let weightKg = this.state.formState.weightKg.value;
    return Math.round(weightKg * this.weightConversionFactor);
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }
  handlePoError(value) {
    const errorClass = value === "" || value === 0 || value === null;
    return errorClass ? true : false;
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    return (
      <>
        <div className="checkFormWrapper patientInfo">
          <FormTitle
            title="Patient Information"
            description="For your convenience, all WillowWood custom product order forms are listed below."
          />

          <form className="checkform">
            <div className="fieldBorder">
              <div className={`fieldWrapper`}>
                <div>
                  <InputTextField
                    label="Patient ID"
                    variant="outlined"
                    placeholder="Patient ID"
                    type="text"
                    required={this.state.formState["patientId"].isRequired}
                    error={this.handleError("patientId") && this.state.isSubmit}
                    value={this.state.formState.patientId.value}
                    onChange={(e) => {
                      this.onInputChange(e, "patientId");
                    }}
                  />
                </div>

                <InputTextField
                  label="PO #"
                  variant="outlined"
                  placeholder="PO"
                  type="text"
                  width="384px"
                  value={this.state.personalData.poNumber}
                  required={true}
                  error={
                    this.handlePoError(this.state.personalData.poNumber) &&
                    this.state.isSubmit
                  }
                  onChange={(e) => {
                    let personalData = this.state.personalData;
                    personalData.poNumber = e.target.value;
                    this.setState({ personalData: personalData });
                  }}
                />
              </div>

              <div className="measurment">
                <MuiRadio
                  options={this.state.patientInfo1UOMs}
                  defaultValue={this.state.formState.patientInfo1UOM.value}
                  error={
                    this.handleError("patientInfo1UOM") && this.state.isSubmit
                  }
                  label="Unit Of Measurement "
                  onChange={(e) => {
                    this.onRadioChange(e, "patientInfo1UOM");
                  }}
                />
              </div>

              <div className="fieldWrapper">
                {this.state.formState.patientInfo1UOM.value === 1 ? (
                  <div className="rangeSlider">
                    <RangeSlider
                      min={30}
                      max={231}
                      label="Height"
                      unit="cm"
                      minValue={"30cm"}
                      maxValue={"231cm"}
                      initialValue={this.state.formState.heightCm.value}
                      onChange={this.handleHeightCmChange}
                    />

                    <RangeSlider
                      min={1}
                      max={225}
                      label="Weight"
                      unit="kg"
                      minValue={"1kg"}
                      maxValue={"255kg"}
                      initialValue={this.state.formState.weightKg.value}
                      onChange={this.handleWeightKgChange}
                    />

                    <RangeSlider
                      min={22}
                      max={31}
                      minValue={"22cm"}
                      maxValue={"31cm"}
                      label="Foot Size"
                      initialValue={this.state.formState.footSize.value}
                      onChange={this.handleFootSizeChange}
                    />
                  </div>
                ) : (
                  <>
                    <RangeSlider
                      min={1}
                      max={6}
                      label="Height"
                      unit="ft"
                      minValue={"1ft"}
                      maxValue={"6ft"}
                      initialValue={this.state.formState.heightFt.value}
                      onChange={this.handleHeightFtChange}
                    />
                    <RangeSlider
                      min={0}
                      max={11}
                      label="Height"
                      unit="in"
                      minValue={"0in"}
                      maxValue={"11in"}
                      initialValue={this.state.formState.heightIn.value}
                      onChange={this.handleHeightInChange}
                    />

                    <RangeSlider
                      min={2}
                      max={496}
                      label="Weight"
                      unit="lbs"
                      minValue={"2lbs"}
                      maxValue={"496lbs"}
                      initialValue={this.state.formState.weightLbs.value}
                      onChange={this.handleWeightLbsChange}
                    />
                    <RangeSlider
                      min={22}
                      max={31}
                      minValue={"22cm"}
                      maxValue={"31cm"}
                      label="Foot Size"
                      initialValue={this.state.formState.footSize.value}
                      onChange={this.handleFootSizeChange}
                    />
                  </>
                )}
              </div>
            </div>

            <div className="fieldBorder">
              <MuiRadio
                options={this.state.footDirections}
                label="Amputation Side"
                required={true}
                defaultValue={this.state.formState.footDirection.value}
                error={this.handleError("footDirection") && this.state.isSubmit}
                onChange={(e) => {
                  this.props.setActiveInnerStep(2);
                  this.onRadioChange(e, "footDirection");
                }}
              />
            </div>

            <div className="">
              <MuiRadio
                options={this.state.kLevels}
                label="K Level"
                checked
                defaultValue={this.state.formState.kLevel.value}
                error={this.handleError("kLevel") && this.state.isSubmit}
                required={true}
                onChange={(e) => {
                  this.props.setActiveInnerStep(3);
                  this.onRadioChange(e, "kLevel");
                }}
              />
            </div>
          </form>
        </div>
        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              disabled={true}
              onClick={() => {
                this.props.handleBack(this?.props?.currentIndex - 1);
                if (this.props.setIsBack) {
                  this.props.setIsBack(true);
                }
              }}
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                try {
                  this.setState({ isLoading: true });
                  const res = await this.saveData();
                  if (res.status === 204) {
                    this.props.handleNext(this.props.currentIndex);
                    this.setState({ isLoading: false });
                    CreateNotification("Submitted", "success");
                  }
                } catch (err) {
                  this.setState({ isLoading: false });
                }
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        
      </>
    );
  }

  getMetricHeight() {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs>
            <Slider
              min={30}
              max={211}
              value={this.state.formState.heightCm.value}
              onChange={this.handleHeightCmChange}
              valueLabelDisplay="auto"
              aria-labelledby="continuous-slider-always"
            />
          </Grid>
          <Grid item>cm</Grid>
        </Grid>
      </>
    );
  }

  getImperialHeight() {
    return (
      <>
        <RangeSlider
          min={1}
          max={6}
          label="Height"
          unit="ft"
          minValue={"1ft"}
          maxValue={"6ft"}
          initialValue={this.state.formState.heightFt.value}
          onChange={this.handleHeightFtChange}
        />
        <RangeSlider
          min={0}
          max={11}
          label="Height"
          unit="in"
          minValue={"0in"}
          maxValue={"11in"}
          initialValue={this.state.formState.heightIn.value}
          onChange={this.handleHeightInChange}
        />
        
      </>
    );
  }

  getHeightText() {
    let formState = this.state.formState;
    if (this.state.formState.patientInfo1UOM.value === this.uomMetric) {
      return formState.heightCm.value + " cm";
    } else {
      return formState.heightFt.value + "' " + formState.heightIn.value + '"';
    }
  }

  getMetricWeight() {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs>
            <Slider
              min={1}
              max={225}
              value={this.state.formState.weightKg.value}
              onChange={this.handleWeightKgChange}
              valueLabelDisplay="auto"
              aria-labelledby="continuous-slider-always"
            />
          </Grid>
          <Grid item>kg</Grid>
        </Grid>
      </>
    );
  }

  getImperialWeight() {
    return (
      <>
        <RangeSlider
          min={2}
          max={496}
          label="Weight"
          unit="lbs"
          minValue={"2lbs"}
          maxValue={"496lbs"}
          initialValue={this.state.formState.weightLbs.value}
          onChange={this.handleWeightLbsChange}
        />

        
      </>
    );
  }

  getWeightText() {
    let formState = this.state.formState;
    if (this.state.formState.patientInfo1UOM.value === this.uomMetric) {
      return formState.weightKg.value + " kg";
    } else {
      return formState.weightLbs.value + " lbs";
    }
  }
}
